import { Typography } from '@mui/material';
import { SlackChannelList } from 'components/SlackChannelList';
import {
  getSlackChannelsFromMetadata,
  LatLngMetadata,
} from 'hooks/useLatLngMetadata';
import { t } from 'i18next';

type MapPinInternalInfoProps = {
  latLngMetadata?: LatLngMetadata | undefined;
};

export const MapPinInternalInfo = (
  props: MapPinInternalInfoProps,
): JSX.Element | null => {
  const { latLngMetadata } = props;

  const {
    wildfireChannel,
    wildfireChannelId,
    floodingChannel,
    floodingChannelId,
  } = getSlackChannelsFromMetadata(latLngMetadata);

  return (
    <>
      <Typography variant="watchduty-section-header">
        {t('slackChannels.title')}
      </Typography>
      <SlackChannelList
        channels={[
          {
            label: t('mapPin.info.slackChannel.wildfire'),
            channelName: wildfireChannel,
            channelId: wildfireChannelId,
          },
          {
            label: t('mapPin.info.slackChannel.flooding'),
            channelName: floodingChannel,
            channelId: floodingChannelId,
          },
        ]}
      />
    </>
  );
};
